import { caES, enUS, esES, frFR, itIT, deDE } from "@mui/material/locale";
import { LocaleObject } from "yup";
import { getCookie, setCookie } from "./services/utils";

export enum Locale {
  CA_ES = "ca-ES",
  EN_GB = "en-GB",
  EN_US = "en-US",
  ES_ES = "es-ES",
  FR_FR = "fr-FR",
  IT_IT = "it-IT",
  DE_DE = "de-DE",
}

export const YUP_CA = {
  array: {
    min: (params: { min: number }) => {
      let str = `Al menys ${params.min} camps`;
      if (params.min > 1) {
        str += "s s'ha de seleccionar";
      } else {
        str += " s'ha de seleccionar";
      }
      return str;
    },
  },
  mixed: { required: "Aquest camp és obligatori" },
};

export const YUP_EN = {
  array: {
    min: (params: { min: number }) => {
      let str = `At least ${params.min} field`;
      if (params.min > 1) {
        str += "s must be selected";
      } else {
        str += " must be selected";
      }
      return str;
    },
  },
  mixed: { required: "This field is required" },
};

export const YUP_ES = {
  array: {
    min: (params: { min: number }) => {
      let str = `Al menos ${params.min} campo`;
      if (params.min > 1) {
        str += "s debe ser seleccionado";
      } else {
        str += " debe ser seleccionado";
      }
      return str;
    },
  },
  mixed: { required: "Este campo es obligatorio" },
};

const YUP_FR = {
  array: {
    min: (params: { min: number }) => {
      let str = `Au moins ${params.min} champ`;
      if (params.min > 1) {
        str += "s doivent être sélectionnés";
      } else {
        str += " doit être sélectionné";
      }
      return str;
    },
  },
  // This is not working and need some debug
  // date: {
  //   min: (params: { min: string | Date } & MessageParams) => "`Fin` doit être supérieure à `Début`",
  // },
  mixed: { required: "Ce champ est requis" },
};

export const YUP_IT = {
  array: {
    min: (params: { min: number }) => {
      let str = `È necessario selezionare almeno ${params.min}`;
      if (params.min > 1) {
        str += " campi";
      } else {
        str += " campo";
      }
      return str;
    },
  },
  mixed: { required: "Questo campo è obbligatorio" },
};

// TODO: add other translations or translations codes
// TODO: move all schema inside of component or move translations in form
//  or move these locale in a component ?
export const YUP_LOCALES: Record<Locale, LocaleObject> = {
  [Locale.CA_ES]: YUP_CA,
  [Locale.FR_FR]: YUP_FR,
  [Locale.EN_GB]: YUP_EN,
  [Locale.EN_US]: YUP_EN,
  [Locale.ES_ES]: YUP_ES,
  [Locale.IT_IT]: YUP_IT,
  [Locale.DE_DE]: YUP_EN, // TODO : change to YUP_DE when all is translated
};

export const BROWSER_LOCALES: {
  [key: string]: Locale;
} = {
  ca: Locale.CA_ES,
  "ca-ES": Locale.CA_ES,
  en: Locale.EN_GB,
  "en-GB": Locale.EN_GB,
  "en-US": Locale.EN_US,
  es: Locale.ES_ES,
  "es-ES": Locale.ES_ES,
  fr: Locale.FR_FR,
  "fr-FR": Locale.FR_FR,
  it: Locale.IT_IT,
  "it-IT": Locale.IT_IT,
  de: Locale.DE_DE,
  "de-DE": Locale.DE_DE,
};

export const LOCALE_MAP = {
  [Locale.CA_ES]: caES,
  [Locale.EN_GB]: enUS,
  [Locale.EN_US]: enUS,
  [Locale.ES_ES]: esES,
  [Locale.FR_FR]: frFR,
  [Locale.IT_IT]: itIT,
  [Locale.DE_DE]: deDE,
};

export const LOCALE_MAP_TRANSLATIONS = {
  [Locale.FR_FR]: "FRENCH",
  [Locale.EN_GB]: "ENGLISH",
  [Locale.ES_ES]: "SPANISH",
  [Locale.CA_ES]: "CATALAN",
  [Locale.IT_IT]: "ITALIAN",
  [Locale.DE_DE]: "GERMAN",
};

export const DEFAULT_LOCALE = Locale.EN_US;

export function initCurrentLocale() {
  const queryParams = new URLSearchParams(window.location.search);
  const lang = queryParams.get("lang");

  const currentLangCookie = getCookie("revbell-lang");

  if (lang && BROWSER_LOCALES[lang]) {
    setCookie("revbell-lang", BROWSER_LOCALES[lang]);
    return BROWSER_LOCALES[lang];
  }

  if (currentLangCookie && BROWSER_LOCALES[currentLangCookie]) {
    return BROWSER_LOCALES[currentLangCookie];
  }

  setCookie(
    "revbell-lang",
    BROWSER_LOCALES[navigator.language] || DEFAULT_LOCALE
  );

  return BROWSER_LOCALES[navigator.language] || DEFAULT_LOCALE;
}

export const getCurrentLocale = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const lang = queryParams.get("lang");
  const currentLangCookie = getCookie("revbell-lang");

  if (!currentLangCookie) {
    return (
      (lang && BROWSER_LOCALES[lang]) ||
      BROWSER_LOCALES[navigator.language] ||
      DEFAULT_LOCALE
    );
  }

  return BROWSER_LOCALES[currentLangCookie] || DEFAULT_LOCALE;
};
